module.exports = __webpack_public_path__ + "static/media/20201216_203539_573_IMG_3218.7af9b4eb.jpg";